var SCM = SCM || {};

SCM.MyInstitutionalTokens = (function ($) {

    var baseUrl;

    return {
        init: init,
        handlePaginationClick: handlePaginationClick
    };

    function init() {
        if ($('.widget-MyInstitutionalTokens').length) {

            baseUrl = SCM.Pagination.trimEndUntilRegexMatches(document.URL.valueOf(), '[a-zA-Z]$');

            SCM.Pagination.enableBrowserHistoryNavigation();
        }
    }

    function handlePaginationClick(jqElement) {

        SCM.Pagination.updateBrowseHistory(baseUrl, baseUrl);

        var ajaxSettings = {
            type: 'POST',
            url: '/UserDashboard/MyInstitutionalTokens/' +
                jqElement.data('parent-instance'),
            cache: false,
            data: {
                selectedPage: jqElement.data('clicked-page')
            }
        };

        SCM.Pagination.performAjaxPagination(ajaxSettings, jqElement);
    }

})(jQuery);

jQuery(function () {
    SCM.MyInstitutionalTokens.init();
});